import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ParcelhistoryService } from '../../../@core/services/parcelhistory.service';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-parcel-history-dialog',
  templateUrl: './parcel-history-dialog.component.html',
  styleUrls: ['./parcel-history-dialog.component.scss']
})
export class ParcelHistoryDialogComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public sub: Subscription;
  public copyTitle: string;
  public copyText: string;
  public search: boolean = false;
  public noresult: boolean = false;
  public searchParcelId: any = '';
  public displayedColumns: string[] = [
    'Exception',
    'Sub-Exception',
    'Position',
    'ExceptionDescription',
    'DateLiv',
    'DepotName',
    'Reason',
    'Contact',
    'UserFullName'
  ];
  public parcelId: string;

  constructor(
    public dialogRef: MatDialogRef<ParcelHistoryDialogComponent>,
    public _parcelhistoryService: ParcelhistoryService,
    public translateService: TranslateService,
    public toastservice: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.sub = this._parcelhistoryService.loadingInProgress.subscribe((res) => {
      this.loading = res;
    });
    this.search = this.data.search;
    this.parcelId = this.data.parcelId;
    this.translateService.get('Copied to clipboard').subscribe((val) => {
      this.copyText = val;
    });
  }

  public close(): void {
    this._parcelhistoryService.clearParcel();
    this.dialogRef.close(false);
  }

  public searchById(): void {
    this._parcelhistoryService.initialiseParcel(this.searchParcelId);
    setTimeout(() => {
      if (
        !this._parcelhistoryService.dataSource ||
        this._parcelhistoryService.dataSource.data.length === 0
      ) {
        this.noresult = true;
        this.parcelId = null;
      } else {
        this.parcelId = this.searchParcelId;
        this.noresult = false;
      }
    }, 100);
  }

  copyParcelId(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastservice.success(null, this.copyText, {
      positionClass: 'toast-bottom-left',
      disableTimeOut: false,
      enableHtml: true
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
